import React from 'react';
import { Link } from 'gatsby';

export default function Nav({ onMenuToggle = () => {} }) {
  return (
    <nav id="nav">
      <ul>
        <li className="special">
          <a
            href="#menu"
            onClick={e => {
              e.preventDefault();
              onMenuToggle();
            }}
            className="menuToggle"
          >
            <span>Menu</span>
          </a>
          <div id="menu">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/double-aortic-arch">Double Aortic Arch</Link>
              </li>
              <li>
                <Link to="/tetralogy-of-fallot">Tetralogy of Fallot</Link>
              </li>
              <li>
                <Link to="/truncus-arteriosus">Truncus Arteriosus</Link>
              </li>
              <li>
                <Link to="/atrial-septal-defect">Atrial Septal Defect</Link>
              </li>
              <li>
                <Link to="/coronary-artery-bypass-grafting">
                  Coronary Artery Bypass
                </Link>
              </li>
              <li>
                <Link to="/ascending-aortic-aneurysm">
                  Ascending Aortic Aneurysm
                </Link>
              </li>
            </ul>
            <a
              className="close"
              onClick={e => {
                e.preventDefault();
                onMenuToggle();
              }}
              href="#menu"
            >
              {''}
            </a>
          </div>
        </li>
      </ul>
    </nav>
  );
}
